import { __awaiter } from "tslib";
import { isTSProject, normalizeDtsOptions, generateTypesAPI, consumeTypesAPI, normalizeGenerateTypesOptions, normalizeConsumeTypesOptions, } from '@module-federation/dts-plugin';
import logger from '../utils/logger';
export function dts(options_1, _a) {
    return __awaiter(this, arguments, void 0, function* (options, { readConfig }) {
        const { fetch = true, generate = true, root = process.cwd(), output, config, } = options;
        const mfConfig = yield readConfig(config);
        if (!isTSProject(mfConfig.dts, root)) {
            logger.error('dts is only supported for TypeScript projects');
            return;
        }
        const normalizedDtsOptions = normalizeDtsOptions(mfConfig, root, {
            defaultGenerateOptions: {
                generateAPITypes: true,
                compileInChildProcess: false,
                abortOnError: true,
                extractThirdParty: false,
                extractRemoteTypes: false,
            },
            defaultConsumeOptions: {
                abortOnError: true,
                consumeAPITypes: true,
            },
        });
        if (!normalizedDtsOptions) {
            logger.error('dts is not enabled in module-federation.config.ts');
            return;
        }
        if (fetch) {
            const dtsManagerOptions = normalizeConsumeTypesOptions({
                context: root,
                dtsOptions: normalizedDtsOptions,
                pluginOptions: mfConfig,
            });
            if (!dtsManagerOptions) {
                logger.warn('dts.consumeTypes is not enabled in module-federation.config.ts, skip fetching remote types');
            }
            else {
                logger.debug('start fetching remote types...');
                yield consumeTypesAPI(dtsManagerOptions);
                logger.debug('fetch remote types success!');
            }
        }
        if (generate) {
            const dtsManagerOptions = normalizeGenerateTypesOptions({
                context: root,
                outputDir: output,
                dtsOptions: normalizedDtsOptions,
                pluginOptions: mfConfig,
            });
            if (!dtsManagerOptions) {
                logger.warn('dts.generateTypes is not enabled in module-federation.config.ts, skip generating types');
                return;
            }
            logger.debug('start generating types...');
            yield generateTypesAPI({ dtsManagerOptions });
            logger.debug('generate types success!');
        }
    });
}
